import React, { useMemo, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Loading from 'components/Loading'
import _ from 'lodash'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import { RadiologyFragment } from '../Radiology'
import NoData from '../../../MyHealthContentArea/NoDataAvailableBar'
import FhirEnhancedActions from '@web/stores/FhirEnhanced/Actions'
import {
  documentBinarySearchLoading,
  documentBinary,
  documentsSearchNextLoading,
  documentBinaryCache,
  documentBinaryPreviewLoading,
  documentBinarySearchError
} from '@web/stores/FhirEnhanced/Select'
import { sortDocuments } from '@web/helpers/sortBy'
import LoadMoreButton from 'components/LoadMoreButton'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'

const binarySearch = {
  name: 'documents',
  request: FhirEnhancedActions.documentBinarySearch,
  preview: FhirEnhancedActions.documentBinaryPreview,
  loading: documentBinarySearchLoading,
  previewLoading: documentBinaryPreviewLoading,
  json: documentBinary,
  cache: documentBinaryCache,
  error: documentBinarySearchError,
  cancelPreview: FhirEnhancedActions.documentBinaryPreviewCancel
}

const Documents = ({ name, loading, data, error }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const items = useMemo(() => {
    return _.get(sortDocuments(data), 'entry', [])
  }, [data])

  const dispatch = useDispatch()

  const isDocumentsNextLoading = useSelector(documentsSearchNextLoading)
  const [allDataLoaded, setAllDataLoaded] = useState(false)

  const getNextData = () => {
    const hasNext = _.get(data, 'link[1].relation') === 'next'
    if (hasNext) {
      const nextUrl = _.get(data, 'link[1].url', '')
      dispatch(FhirEnhancedActions.documentsSearchNext(nextUrl))
    } else {
      setAllDataLoaded(true)
    }
  }

  useEffect(() => {
    const hasNext = _.get(data, 'link[1].relation') === 'next'
    setAllDataLoaded(!hasNext)
  }, [data])

  return (
    <div style={styles.container}>
      {loading && _.isEmpty(items) && <Loading />}
      {!_.isEmpty(items) && (
        <RadiologyFragment
          binarySearch={binarySearch}
          items={items}
          lableLeft={'document'}
        />
      )}
      {!loading &&
        _.isEmpty(items) &&
        (error ? <SthWentWrong /> : <NoData name={name} />)}
      {!allDataLoaded ? (
        <div style={styles.loadMoreButtonWrapper}>
          <LoadMoreButton
            loading={isDocumentsNextLoading}
            onClick={getNextData}
          />
        </div>
      ) : null}
    </div>
  )
}

export default Documents
